import "../../styles/googleAppleBtn.css";

const GooglePlayBlack = () => (
    <a
        href="https://play.google.com/store/apps/details?id=com.nuqi.nuqiwealthapp"
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center justify-center bg-black text-white rounded-lg px-4 py-2.5 hover:bg-gray-800 transition-colors"
    >
        <svg viewBox="0 0 512 512" className="w-7 h-7 mr-3" fill="currentColor">
            <path d="M99.617 8.057a50.191 50.191 0 00-38.815-6.713l230.932 230.933 74.846-74.846L99.617 8.057zM32.139 20.116c-6.441 8.563-10.148 19.077-10.148 30.199v411.358c0 11.123 3.708 21.636 10.148 30.199l235.877-235.877L32.139 20.116zM464.261 212.087l-67.266-37.637-81.544 81.544 81.548 81.548 67.273-37.64c16.117-9.03 25.738-25.442 25.738-43.908s-9.621-34.877-25.749-43.907zM291.733 279.711L60.815 510.629c3.786.891 7.639 1.371 11.492 1.371a50.275 50.275 0 0027.31-8.07l266.965-149.372-74.849-74.847z"></path>
        </svg>
        <div className="text-left">
            <div className="text-xs">GET IT ON</div>
            <div className="text-xl font-semibold -mt-1">Google Play</div>
        </div>
    </a>
);

const AppStoreBlack = () => (
    <a
        href="https://apps.apple.com/in/app/nuqi-wealth-india/id6467738605"
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center justify-center bg-black text-white rounded-lg px-4 py-2.5 hover:bg-gray-800 transition-colors"
    >
        <svg
            viewBox="0 0 384 512"
            className="w-7 h-7 mr-3"
            fill="currentColor"
        >
            <path d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z" />
        </svg>
        <div className="text-left">
            <div className="text-xs">Download on the</div>
            <div className="text-xl font-semibold -mt-1">App Store</div>
        </div>
    </a>
);

const AppDownload = () => {
    return (
        <div className="min-h-screen flex items-center justify-center p-4">
            <div className="bg-white rounded-3xl shadow-2xl max-w-md w-full p-8 flex flex-col items-center">
                {/* Logo */}
                <div className="w-40 h-40 bg-[#1a1a1a] rounded-3xl flex items-center justify-center mb-6 shadow-[0_20px_50px_rgba(0,0,0,0.3),0_10px_20px_rgba(0,0,0,0.2),inset_0_-2px_6px_rgba(255,255,255,0.1)] border border-gray-700">
                    <img
                        src="/white-in-logo-cropped.png"
                        alt="NUQI Wealth Logo"
                        className="w-28 h-28 object-contain"
                    />
                </div>

                {/* Title */}
                <h1 className="text-2xl md:text-3xl font-bold text-[#1a1a1a] mb-2 text-center tracking-wide">
                    NUQI WEALTH INDIA
                </h1>

                {/* URL */}
                <a
                    href="https://portal.nuqiwealth.in"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-600 mb-6 hover:text-[#57c0af] transition-colors"
                >
                    https://portal.nuqiwealth.in
                </a>

                {/* Description */}
                <p className="text-gray-600 text-center leading-relaxed mb-8 text-sm md:text-base">
                    NUQI is an independent advisory platform, licensed by SEBI in India
                    aimed at both first-time investors starting their investment journey
                    and seasoned investors looking to diversify their portfolio. NUQI
                    deploys its in-house expertise to create portfolios tailored for
                    specific investor profiles and investment themes. The platform uses
                    multiple criteria to make a selection of Stocks, ETFs, Mutual funds,
                    etc., with Social Equity, Ethical operations, Good Governance, and
                    Environmental protection as core investment themes aimed towards
                    Sustainable Growth.
                </p>

                {/* Download Buttons */}
                <div className="flex flex-col gap-4 w-full max-w-xs">
                    <GooglePlayBlack />
                    <AppStoreBlack />
                </div>
            </div>
        </div>
    );
};

export default AppDownload;
